export {}

import {pushToDataLayer} from "js/data-layer/data-layer"

const serviceSectionFilters = document.querySelectorAll<HTMLElement>(".f-service")

serviceSectionFilters.forEach((filter) => {
  filter?.addEventListener("beforeFetch", () => {
    pushToDataLayer("click_filter")
  })
})

